import React from 'react';
import classes from './style.module.css'
import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { passStringToDateWithFormat } from '../../../util/date/date-utils'

const DatePicker = props => {

   return (
       <div className={classes.DatePicker}>
                <span>Date:</span>
                <ReactDatePicker
                    dateFormat="yyyy/MM/dd"
                    selected={passStringToDateWithFormat(props.selectedDate, 'YYYYMMDD')}
                    onChange={(event) => props.selectedDateChanged(event)}
                    />
       </div>
   );
}

export default DatePicker;